import { usePaymentNotification } from '@/hooks/paymentNotification';

export const PaymentNotification = () => {
  usePaymentNotification();

  return null;
};
